import GameHostPage from "./GameHostPage";
import "./game-host-page.scss";

export default GameHostPage;
